import { initializeEventNameTracking } from './logEventWithEventName'

const AnalyticsPlugin = {
    install(app: any) {
        initializeEventNameTracking(app)
    },
}

export default AnalyticsPlugin
